import React from 'react';

const Contact = () => {
  return (
    <div>
      <h1>Contact Page</h1>
      <p>Welcome to the Contact Page</p>
    </div>
  );
};

export default Contact;
